<template>
  <div class="c-help">
    <sheet maxWidth="400">
      <div class="title">
        <div class="title__left">
          <p class="title__left__text">請確認欲取消訂閱電子報的email</p>
        </div>
      </div>
      <div class="form-wrap">
        <Form :validation-schema="schema" @submit="onSubmit">
          <pr-form-item label="*EMAIL：">
            <pr-input v-model="form.email" placeholder="請輸入您的EMAIL" type="text" name="email" autocomplete="off" />
          </pr-form-item>

          <pr-form-item submit>
            <pr-button @click="handleSubmit" width="100%">取消訂閱</pr-button>
          </pr-form-item>
        </Form>
      </div>
    </sheet>

    <pr-dialog v-model:visible="dialogVisible.success" appendToBody>
      <!-- FIXED: 應從內部去關閉 -->
      <subscribe-success @closeDialog="closeDialog" />
    </pr-dialog>
  </div>
</template>
<script>
import {
  defineComponent, reactive,
  // computed, watch,
} from 'vue';
import { Form } from 'vee-validate';
import yup from '@/utils/yup';
import PrFormItem from '@/components/Form/PrFormItem.vue';
import PrInput from '@/components/Form/PrInput.vue';
import PrButton from '@/components/Global/PrButton.vue';
import PrDialog from '@/components/Global/Dialog.vue';
import SubscribeSuccess from '@/components/Dialog/SubscribeSuccess.vue';
import errMsg from '@/utils/yup/yupCustomErrMsg';
// import { useSiteStore } from '@/store/site';
import { cancelSubscribeAPI } from '@/api/subscribe';

export default defineComponent({
  name: 'Unsubscribe',
  components: {
    PrFormItem,
    PrInput,
    PrButton,
    PrDialog,
    SubscribeSuccess,
    Form,
  },
  setup() {
    // const siteStore = useSiteStore();
    const dialogVisible = reactive({
      success: false,
    });

    const form = reactive({
      email: '',
    });

    const schema = yup.object().shape({
      email: yup.string().customEmail({ errMsg: errMsg.email }).required(errMsg.required(' Email')),
    });

    const onSubmit = (values) => {
      console.log('form', JSON.stringify(values, null, 2));
    };

    const openDialog = (type) => {
      dialogVisible[type] = true;
    };

    const closeDialog = (type) => {
      dialogVisible[type] = false;
    };

    const handleSubmit = async () => {
      const isValid = await schema.isValid(form);
      console.log('isValid', isValid);
      if (!isValid) return;

      try {
        const payload = {
          email: form.email,
        };

        const res = await cancelSubscribeAPI(payload);

        // TOFIX 後端似乎還沒處理
        if (res.status) {
          openDialog('success');
        }
      } catch (e) {
        console.log('e', e);
      }
    };

    // const memberInfo = computed(() => siteStore.memberInfo);

    // 因為頁面沒有連結可以進來，所以一定是用網址進來的，等
    // 剛進來時，App.vue 拿到user資料時帶入，若沒有 token，就沒事
    // watch(() => memberInfo.value, () => {
    //   const { email } = memberInfo.value;
    //   form.email = email;
    // }, { deep: true });

    return {
      form,
      schema,
      onSubmit,
      handleSubmit,
      openDialog,
      closeDialog,
      dialogVisible,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '~@/styles/share/memberTitle.scss';

.form-wrap {
  margin-top: 28px;
}

.cancel-subscribe {
  margin-top: 64px;
  text-align: center;
  @include font-style($c-grey, 14, 400, 1px, 26px);
}
</style>
